import {
  BlockText,
  BlockWebform,
  BlockCTA,
} from '../implementations';

const mappers = {
  text: BlockText,
  webform_block: BlockWebform,
  cta: BlockCTA,
};

export default mappers;
